exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* iPhone 7 plus is the smallest device*/\n.search-box {\n  position: absolute;\n  z-index: 1000;\n  background-image: linear-gradient(#D9EDF7, #e0f5ff);\n  border-radius: 5px;\n  margin-top: -10px;\n  margin-left: 5px;\n  width: 95%;\n  box-shadow: 1px 1px 5px 0 #000000; }\n  @media only screen and (max-device-width: 414px) {\n    .search-box li > a {\n      padding: 6px 15px; } }\n  @media only screen and (min-device-width: 415px) and (max-device-width: 767px) {\n    .search-box li > a {\n      padding: 6px 15px; } }\n\n.search-input {\n  margin-top: 5px;\n  margin-left: 5px;\n  width: 95%; }\n  @media only screen and (max-device-width: 414px) {\n    .search-input {\n      height: 28px;\n      font-size: 12px; } }\n  @media only screen and (min-device-width: 415px) and (max-device-width: 767px) {\n    .search-input {\n      height: 28px;\n      font-size: 12px; } }\n\n.loading-container {\n  display: table;\n  margin: 0 auto;\n  padding-top: 70px;\n  min-height: 200px; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./app/components/search-box/view/search-box.scss
 ** module id = 678
 ** module chunks = 0
 **/